module.exports = __webpack_public_path__ + "img/icon-tiler.8909f54a.png";